import { createLocalStorage } from './storage';

export type MiniAppLang = 'ru_RU' | 'en_US' | 'be_BY' | 'kk_KZ';
const validLangs = new Set(['ru_RU', 'en_US', 'be_BY', 'kk_KZ']);

export const langStorage = createLocalStorage('lang');

const isValidLang = (lang: string): lang is MiniAppLang => {
  return validLangs.has(lang);
};

export const getDocumentLang = () => {
  const selectedLang = String(langStorage.get());
  if (isValidLang(selectedLang)) {
    return selectedLang;
  }

  const currentLang = window.navigator.language;
  const defaultLang = 'ru_RU';
  const supportedLangs = {
    ru_RU: /ru/,
    en_US: /en/,
    be_BY: /be/,
    kk_KZ: /(kz|kk)/,
  };

  const availableLangs = Object.keys(supportedLangs) as Array<keyof typeof supportedLangs>;
  return availableLangs.find((lang) => currentLang.match(supportedLangs[lang])) || defaultLang;
};

export const VKIDAuthLangCode = {
  ru_RU: 0,
  en_US: 3,
  be_BY: 97,
  kk_KZ: 114,
};

export const SDKLangCode = {
  ru_RU: 0,
  en_US: 3,
  be_BY: 114,
  kk_KZ: 97,
};

export const VkTranslationsLangCode = {
  ru_RU: 'ru',
  en_US: 'en',
  be_BY: 'be',
  kk_KZ: 'kz',
};
